module.exports = __webpack_public_path__ + "img/Slide20.60c62462.png";